import { useEffect } from 'react';
import { LexicalEditor } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

type Props = { onReady: (editor: LexicalEditor) => void };

export default function CasEditorReadyPlugin({ onReady }: Props) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    onReady?.(editor);
  }, [editor, onReady]);

  return null;
}
